import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.Home.PropertyComplianceTab.SetAsideSummary.Graph.Title',
    defaultMessage: 'Income Average',
  },
  required: {
    id: 'App.Home.PropertyComplianceTab.SetAsideSummary.Graph.Required',
    defaultMessage: 'Required',
  },
  actual: {
    id: 'App.Home.PropertyComplianceTab.SetAsideSummary.Graph.Actual',
    defaultMessage: 'Actual',
  },
});

export default messages;
